<div class="upload-section" [class.drop-disabled]="disabled">
  <div class="drop-zone" appDnd (fileDropped)="selectFiles($event)"></div>

  <div *ngIf="isShowUpload"
       class="dropzone-container flex flex-column justify-content-center align-items-center"
       appDnd
       (fileDropped)="selectFiles($event)">
    <input type="file"
           id="fileDropRef"
           [multiple]="multiple"
           (change)="selectFiles($event)" />
    <div>
      <i class="fas fa-cloud-upload-alt"></i>
    </div>
    <div>Drop file here to upload</div>
    <div class="or">or</div>
    <label for="fileDropRef" class="browse-files">Browse files</label>
  </div>
  <!--<div class="flex justify-content-center" *ngIf="isShowUpload">
    {{ categoryName }}
  </div>-->
  <div *ngIf="!isShowUpload" class="flex h-100 flex-column justify-space-between align-items-center ">
    <div class="placeholder  flex flex-column justify-content-center align-items-center">?</div>
    <div class="flex mt-3 justify-content-center">
      {{ categoryName }}
    </div>
  </div>
 
</div>
